module.exports = __webpack_public_path__ + "img/hf5bm.c09ab74c.jpg";